import React from 'react';
import styles from '../SideDrawer.module.scss';

function SideDrawerMobileLayout({ children }: { children?: React.ReactNode }) {
    return <div className={styles.MobileLayout}>{children}</div>;
}

export default SideDrawerMobileLayout;
